var map = {
	"./-m-mine.svg": 5784,
	"./address.svg": 7780,
	"./bug.svg": 2737,
	"./ces.svg": 4180,
	"./enterAccount.svg": 2601,
	"./funcUser.svg": 6445,
	"./home.svg": 9430,
	"./info.svg": 1514,
	"./invoice.svg": 6267,
	"./kefu.svg": 3227,
	"./myAccount.svg": 1746,
	"./news.svg": 4200,
	"./notice.svg": 5612,
	"./order.svg": 3123,
	"./recommend.svg": 7632,
	"./user.svg": 711,
	"./userInfo.svg": 2240
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;